import Spacer from "@/components/atoms/utilities/Spacer";
import { css } from "@emotion/react";
import { ContentFooter, GlobalHeader } from "@/components/organisms";
import { useIsSpMode } from "@/hooks";
import { Footer } from "@moneyforward/mfx_biz_react_components";
import Head from "next/head";

type Props = {
  children?: React.ReactNode;
  term?: boolean;
  title?: String;
  disableAccountDropDown?: boolean;
  disableLogoLink?: boolean;
  disableFooter?: boolean;
};

export const MainTemplate = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={root} id="root">
      {props.title && (
        <Head>
          <title>{`${props.title}｜Mikatano ID`}</title>
        </Head>
      )}
      <GlobalHeader
        term={props.term}
        disableAccountDropDown={props.disableAccountDropDown}
        disableLogoLink={props.disableLogoLink}
      />
      <main css={main}>
        <div css={contentWrapper}>
          <div css={!isSpMode ? content : spModeContent}>
            <div css={!isSpMode ? contentInner : spModeContentInner}>
              <div>{props.children}</div>
            </div>
          </div>
          {!props.term && !props.disableFooter ? <ContentFooter /> : null}
        </div>
      </main>
    </div>
  );
};

const root = css({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
});

const main = css({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  zIndex: 1,
});

const contentWrapper = css({
  flex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const content = css({
  flex: 1,
  width: "984px",
  display: "flex",
  flexDirection: "column",
});

const spModeContent = css({
  flex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
});

const contentInner = css({
  flex: 1,
  marginTop: "40px", // global header
  paddingTop: "56px", //  content padding
  paddingBottom: "56px",
});

const spModeContentInner = css({
  flex: 1,
  marginTop: "40px", // global header
  padding: "56px 16px",
});
